import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ ...args }) {
    super(args)
    const child = this.getComponentWithVModel('invoice')
    this.children = [child]
  }
}
